/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Pin_TitleInputs */

const en_voice_manager_pin_title = /** @type {(inputs: Voice_Manager_Pin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pin`)
};

const fr_voice_manager_pin_title = /** @type {(inputs: Voice_Manager_Pin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Epingler`)
};

const de_voice_manager_pin_title = /** @type {(inputs: Voice_Manager_Pin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stift`)
};

const it_voice_manager_pin_title = /** @type {(inputs: Voice_Manager_Pin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spillo`)
};

const ru_voice_manager_pin_title = /** @type {(inputs: Voice_Manager_Pin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приколоть`)
};

const es_voice_manager_pin_title = /** @type {(inputs: Voice_Manager_Pin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfiler`)
};

const zh_cn2_voice_manager_pin_title = /** @type {(inputs: Voice_Manager_Pin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`别针`)
};

const ja_voice_manager_pin_title = /** @type {(inputs: Voice_Manager_Pin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ピン`)
};

const hi_voice_manager_pin_title = /** @type {(inputs: Voice_Manager_Pin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नत्थी करना`)
};

const pt_pt2_voice_manager_pin_title = /** @type {(inputs: Voice_Manager_Pin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alfinete`)
};

/**
* | output |
* | --- |
* | "Pin" |
*
* @param {Voice_Manager_Pin_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_pin_title = /** @type {((inputs?: Voice_Manager_Pin_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Pin_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voice_manager_pin_title(inputs)
	if (locale === "de") return de_voice_manager_pin_title(inputs)
	if (locale === "it") return it_voice_manager_pin_title(inputs)
	if (locale === "ru") return ru_voice_manager_pin_title(inputs)
	if (locale === "es") return es_voice_manager_pin_title(inputs)
	if (locale === "zh-CN") return zh_cn2_voice_manager_pin_title(inputs)
	if (locale === "ja") return ja_voice_manager_pin_title(inputs)
	if (locale === "hi") return hi_voice_manager_pin_title(inputs)
	if (locale === "pt-PT") return pt_pt2_voice_manager_pin_title(inputs)
	return en_voice_manager_pin_title(inputs)
});